export default "__VITE_ASSET__2d5f1758__"